<template>
  <dialog class="modal" :class="{ 'modal-open': isOpen }">
    <div class="modal-box max-w-lg w-full">
      <div class="flex items-start justify-between gap-4 mb-4">
        <div>
          <h3 class="font-bold text-lg text-base-content">{{ t('contacts.modal.title') }}</h3>
          <p class="text-sm text-base-content/60 mt-1">{{ t('contacts.modal.subtitle') }}</p>
        </div>
        <button
          type="button"
          class="btn btn-sm btn-circle btn-ghost shrink-0"
          :aria-label="t('contacts.modal.close')"
          @click="closeContactModal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>

      <ContactForm mode="modal" @close="closeContactModal" />
    </div>
    <form method="dialog" class="modal-backdrop">
      <button type="button" @click="closeContactModal">{{ t('contacts.modal.close') }}</button>
    </form>
  </dialog>
</template>

<script setup>
import useLocale from '../compositions/useLocale';
import useContactModal from '../compositions/useContactModal';
import ContactForm from '../views/contacts/components/form/create.vue';

const { t } = useLocale();
const { isOpen, closeContactModal } = useContactModal();
</script>
